<template>
	<line-chart
		:chart-data="chartData"
		:chart-options="chartOptions"
	></line-chart>
</template>

<script>
import Vue from "vue";
// Other components
import { i18n } from "../../utils";
import LineChart from "./line_chart.vue";

export default {
	name: "analysis-indicator-line-chart",
	mixins: [i18n],
	props: {
		rawChartData: Object,
		valueUnit: String,
		chartColors: Object,
		chartId: String,
	},
	data() {
		return {
			userDataSetSelection: null,
		};
	},
	components: {
		"line-chart": LineChart,
	},
	computed: {
		chartOptions() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				// Can't use this, otherwise line charts will scale in from the top left when they change from 'hidden' to being shown
				transitions: false,
				elements: {
					line: {
						tension: 0, // Does not seem to do anything at all if `cubicInterpolationMode` is set to 'monotone'
						cubicInterpolationMode: "monotone",
					},
				},
				plugins: {
					legend: {
						display: false,
					},
				},
				scales: {
					y: {
						beginAtZero: false,
						display: true,
						gridLines: {
							display: true,
							color: "#ccc",
							borderDash: [],
						},
						ticks: {
							callback: (value, index, values) => {
								const fromattedNumber = window
									.numeral(value)
									.format(window.numeral.formatWithUnit);
								return `${fromattedNumber} ${this.valueUnit}`;
							},
						},
					},
				},
			};
		},
		chartData() {
			let convertedChartData = _.cloneDeep(this.rawChartData);

			let datasets = [];
			// @ts-expect-error
			Object.entries(this.rawChartData.datasets).forEach(
				([datasetId, dataset]) => {
					if (
						dataset.backgroundColor === undefined &&
						dataset.borderColor === undefined
					) {
						if (dataset.colorClass) {
							dataset.backgroundColor = dataset.borderColor =
								pp.viewHelpers.detectCssRuleFor(
									dataset.colorClass,
									"background-color",
								);
						} else {
							console.error(
								`Unable to find a color for ${dataset.label} in the graph ${this.chartId}`,
							);
						}
					}
					Object.assign(dataset, {
						fill: false,
						hidden: !this.selectedDatasets.includes(datasetId),
						value_unit: this.valueUnit, // The AnalysisTooltip will not see it otherwise
					});
					datasets.push(dataset);
				},
			);
			// @ts-expect-error
			convertedChartData.datasets = datasets;
			return convertedChartData;
		},
		selectedDatasets() {
			// @ts-expect-error
			const defaultDatasets = Object.keys(this.rawChartData.datasets);
			return this.userDataSetSelection
				? this.userDataSetSelection
				: defaultDatasets;
		},
	},
	mounted() {
		pp.vue.bus.$on("CHART-datasets_changed", (data) => {
			if (data.chartId == this.chartId) {
				this.userDataSetSelection = data.datasetIds;
			}
		});
	},
	beforeDestroy() {
		pp.vue.bus.$off("CHART-datasets_changed");
	},
	methods: {},
};
</script>
